import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
import { MediaValueReport } from '../../types/api';
import { sortKeysAndStringify } from '../utils/broadcastsUtils';

const fetchMediaValueReports = async (query): Promise<MediaValueReport> => {
    const response = await sportsApi
        .url('/media-value-reports')
        .json(query)
        .post()
        .json();

    return response as unknown as MediaValueReport;
};

const useMediaValueReports = (query, enabled = true) => {
    return useQuery(
        ['MediaValueReportsKey', sortKeysAndStringify(query)],
        () => fetchMediaValueReports(query),
        { enabled },
    );
};

export default useMediaValueReports;
